import React, { useContext } from "react";
import { LanguageContext } from "../LanguageContext";
import { Link } from "react-router-dom";
import "./InformationalPages.css";
import SEO from "../components/SEO";

const Terms = () => {
  const { language } = useContext(LanguageContext);

  const metaTitle = "Terms and Conditions - Snapseed QR Codes";
  const metaDescription = "Read the terms and conditions that govern the use of Snapseed QR Codes website and services.";
  const metaUrl = "https://www.snapseedqrcodes.download/terms";
  const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.snapseedqrcodes.download/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Terms and Conditions",
        "item": metaUrl
      }
    ]
  };

  return (
    <div className="informational-page">
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={breadcrumbSchema}
      />

      <h1>{language === "english" ? "Terms and Conditions" : "नियम और शर्तें"}</h1>

      <h3>{language === "english" ? "1. Introduction" : "1. परिचय"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? <>These terms apply to your use of Snapseedqrcodes.download. By using this website, you agree to comply with these terms. For data-related concerns, please refer to our <Link to="/privacy-policy">Privacy Policy</Link>.</>
          : <>ये शर्तें Snapseedqrcodes.download के उपयोग पर लागू होती हैं। इस वेबसाइट का उपयोग करके, आप इन शर्तों का पालन करने के लिए सहमत होते हैं। डेटा से संबंधित चिंताओं के लिए कृपया हमारी <Link to="/privacy-policy">गोपनीयता नीति</Link> देखें।</>
        }
      </p>

      <h3>{language === "english" ? "2. Use of Website" : "2. वेबसाइट का उपयोग"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? "You agree to use the website only for lawful purposes and not to disrupt its services."
          : "आप सहमत हैं कि आप वेबसाइट का उपयोग केवल कानूनी उद्देश्यों के लिए करेंगे और इसकी सेवाओं में कोई बाधा नहीं डालेंगे।"}
      </p>

      <h3>{language === "english" ? "3. Intellectual Property" : "3. बौद्धिक संपदा"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? "All content is owned by Snapseed QR Codes and may not be copied or redistributed without permission."
          : "सभी सामग्री Snapseed QR Codes की संपत्ति है और अनुमति के बिना कॉपी या पुनः वितरित नहीं की जा सकती।"}
      </p>

      <h3>{language === "english" ? "4. Limitation of Liability" : "4. देयता की सीमा"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? "We do our best to provide accurate information but make no warranties. We are not responsible for damages from using this site."
          : "हम सटीक जानकारी प्रदान करने का प्रयास करते हैं लेकिन किसी प्रकार की गारंटी नहीं देते। इस साइट के उपयोग से उत्पन्न नुकसान के लिए हम जिम्मेदार नहीं हैं।"}
      </p>

      <h3>{language === "english" ? "5. Changes to Terms" : "5. शर्तों में परिवर्तन"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? "We may update these terms. Continued use of the website means acceptance of the updated terms."
          : "हम इन शर्तों को समय-समय पर अपडेट कर सकते हैं। वेबसाइट का निरंतर उपयोग अपडेटेड शर्तों की स्वीकृति को दर्शाता है।"}
      </p>

      <h3>{language === "english" ? "6. Contact Information" : "6. संपर्क जानकारी"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? <>If you have any questions, please <Link to="/contact">contact us</Link> or visit our <Link to="/about">About Us</Link> page.</>
          : <>यदि आपके कोई प्रश्न हैं, तो कृपया <Link to="/contact">संपर्क करें</Link> या हमारा <Link to="/about">हमारे बारे में</Link> पृष्ठ देखें।</>}
      </p>
    </div>
  );
};

export default Terms;
